import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, pluck, switchMap} from 'rxjs/operators';
import {EmailRendererClient} from './email-renderer-client/email-renderer-client';
import {SerializedEmailRendererClient} from './email-renderer-client/serialized-email-renderer-client';

@Injectable()
export class EmailRendererClientsService {
    constructor(private httpClient: HttpClient) {
    }

    /**
     * Return a list of available client types for use in testing
     */
    public get(): Observable<Array<EmailRendererClient>> {
        return this.httpClient.get<Array<string>>(`https://api.emailonacid.com/v5/email/clients/default`, {
            headers: {
                Authorization: `Basic ${btoa('Y1Koj3MKhYfiz5SAgGTBTluRJy3Z8P7nwJjT3UDC:7Fk0G2KVUiRaNnT6sH8v')}`
            }
        }).pipe(pluck('clients'), switchMap((serializedEmailRendererClientIds: Array<string>) => {
            return this.httpClient.get<Array<SerializedEmailRendererClient>>('https://api.emailonacid.com/v5/email/clients', {
                headers: {
                    Authorization: `Basic ${btoa('Y1Koj3MKhYfiz5SAgGTBTluRJy3Z8P7nwJjT3UDC:7Fk0G2KVUiRaNnT6sH8v')}`
                }
            }).pipe(pluck('clients'), map((serializedEmailRendererClients: Array<SerializedEmailRendererClient>) => {
                return Object.values(serializedEmailRendererClients).filter((serializedEmailRendererClient) => serializedEmailRendererClientIds.includes(serializedEmailRendererClient.id)).map((serializedEmailRendererClient) => {
                    return new EmailRendererClient({
                        browser: serializedEmailRendererClient.browser,
                        category: serializedEmailRendererClient.category,
                        client: serializedEmailRendererClient.client,
                        id: serializedEmailRendererClient.id,
                        os: serializedEmailRendererClient.os
                    });
                });
            }));
        }));
    }

    /**
     * Set the list of available clients. Return the list from the GET endpoint so that the returned list is
     * complete with all required details.
     */
    public post(clients: Array<string>): Observable<Array<EmailRendererClient>> {
        return this.httpClient.post<any>(`https://api.emailonacid.com/v5/email/clients/default`, {
            clients
        }, {
            headers: {
                Authorization: `Basic ${btoa('Y1Koj3MKhYfiz5SAgGTBTluRJy3Z8P7nwJjT3UDC:7Fk0G2KVUiRaNnT6sH8v')}`
            }
        }).pipe(switchMap(() => {
            return this.get();
        }));
    }
}
